<template>
  <b-form-row>
    <b-modal
      size="xl"
      button-size="sm"
      ref="finder"
      hide-footer
      :id="this.id"
      :title="title"
    >
      <ContaContabilList :prefix="updatedPrefix" @onDblClickContaContabil="contaContabilSelect" />
    </b-modal>

    <lg-form-input-finder
      :value="computedValue"
      @input="updateValue"
      fieldDescription="descricao"
      :label="label"
      invalidFeedback="Conta Contábil deve ser informada!"
      description=""
      @handleClean="handleClean"
    >
      <template #prepend>
        <b-button
          @click="show"
          class="btn-input-finder"
          pressed
        >
          <b-icon icon="search" />
        </b-button>
      </template>
    </lg-form-input-finder>
  </b-form-row>
</template>

<script>
import LgFormInputFinder from "@/core/components/Form/LgFormInputFinder.vue"
import ContaContabilList from "@/modules/cadastros/conta-contabil/ContaContabilList.vue"

export default {
  components: { LgFormInputFinder, ContaContabilList },
  props: {
    id: String,
    prefix: Array,
    value: Object,
    label: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      internalValue: this.value || {},
    };
  },
  watch: {
    value(newValue) {
      this.internalValue = newValue;
    },
  },
  computed: {
    computedValue: {
      get() {
        return this.internalValue;
      },
      set(newValue) {
        this.internalValue = newValue;
      },
    },
    updatedPrefix() {
      return [...this.prefix, "Conta Contábil"];
    },
    title() {
      return this.updatedPrefix.join(" > ");
    },
  },
  methods: {
    show() {
      this.$bvModal.show(this.id);
    },
    updateValue(newValue) {
      this.computedValue = newValue;
      this.$emit('input', newValue);
    },
    handleClean() {
      this.computedValue = {};
      this.$emit('input', {});
    },
    contaContabilSelect(item) {
      this.computedValue = item;
      this.$emit('input', item);
      this.$bvModal.hide(this.id);
    },
  },
};
</script>
